import "reset-css";
import "swiper/css";
import "./scss/index.scss";
import { store } from "./store/store";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import { ToastContainer } from "react-toastify";

import { StackNavigator } from "./navigation/StackNavigator";
import { client } from "./services/apollo";
import JWTAuthProvider from "./services/auth/jwt/JwtAuthProvider";

import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <JWTAuthProvider>
          <StackNavigator />
          <ToastContainer />
        </JWTAuthProvider>
      </Provider>
    </ApolloProvider>
  );
}

export default App;
